export const getGoogleFontUrl = (
	fontName: string,
	weights: number[] = [300, 400, 500, 600, 700],
): string => {
	const baseUrl = "https://fonts.googleapis.com/css2";

	// Replace spaces with '+'
	const formattedName = fontName.split(" ").join("+");

	let weightParam = "";
	if (weights.length > 0) {
		// Sort weights to ensure API consistency
		const sortedWeights = weights.sort().join(";");
		weightParam = `:wght@${sortedWeights}`;
	}

	return `${baseUrl}?family=${formattedName}${weightParam}&display=swap`;
};
